import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  EdPortfolioApi,
  PortfolioQuery,
  RemoveFromPortfolioResult,
  SmeOutreachResult,
  SmePortfolioPage,
  SmePortfolioRecord,
} from '../tokens/ed-portfolio.token';

/**
 * REST implementation of the E-D SME-portfolio API (PRD §3.2 / §2.3, EM-825/826).
 *
 *   GET    /services/embedded/api/v1/ed/portfolio
 *   GET    /services/embedded/api/v1/ed/smes/{id}
 *   DELETE /services/embedded/api/v1/ed/smes/{id}
 *   POST   /services/embedded/api/v1/ed/smes/{id}/resend-invite   (EM-1845)
 *   POST   /services/embedded/api/v1/ed/smes/{id}/remind          (EM-1845)
 *
 * The calling E-D is resolved server-side from the JWT (Rule 22 — no id in the URL).
 * REST-only (Rules 07/10). Bound to ED_PORTFOLIO in mock-data.providers.ts.
 */
@Injectable({ providedIn: 'root' })
export class EdPortfolioRestService implements EdPortfolioApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed`;

  getPortfolio(query: PortfolioQuery): Observable<SmePortfolioPage> {
    let params = new HttpParams();
    if (query.status) params = params.set('status', query.status);
    if (query.origin) params = params.set('origin', query.origin);
    if (query.sort) params = params.set('sort', query.sort);
    if (query.page !== undefined && query.page !== null) params = params.set('page', String(query.page));
    if (query.size !== undefined && query.size !== null) params = params.set('size', String(query.size));
    return this.http.get<SmePortfolioPage>(`${this.base}/portfolio`, { params });
  }

  getSmeDetail(id: number): Observable<SmePortfolioRecord> {
    return this.http.get<SmePortfolioRecord>(`${this.base}/smes/${id}`);
  }

  removeFromPortfolio(id: number): Observable<RemoveFromPortfolioResult> {
    return this.http.delete<RemoveFromPortfolioResult>(`${this.base}/smes/${id}`);
  }

  resendInvite(id: number): Observable<SmeOutreachResult> {
    return this.http.post<SmeOutreachResult>(`${this.base}/smes/${id}/resend-invite`, {});
  }

  remind(id: number): Observable<SmeOutreachResult> {
    return this.http.post<SmeOutreachResult>(`${this.base}/smes/${id}/remind`, {});
  }
}
